"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetNamingRuleType = void 0;
var NetNamingRuleType;
(function (NetNamingRuleType) {
    NetNamingRuleType[NetNamingRuleType["LocalNaming"] = 0] = "LocalNaming";
    NetNamingRuleType[NetNamingRuleType["Group"] = 1] = "Group";
    NetNamingRuleType[NetNamingRuleType["Naming"] = 2] = "Naming";
    NetNamingRuleType[NetNamingRuleType["Finalize"] = 3] = "Finalize";
})(NetNamingRuleType || (exports.NetNamingRuleType = NetNamingRuleType = {}));
//# sourceMappingURL=NetNamingRules.js.map